import React from 'react';
import { TrendingUp } from 'lucide-react';
import { TabPnl } from './Reports';

// Standalone page for the rough income-vs-expenses view (sidebar under Reports).
export default function ProfitLoss() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <TrendingUp size={22} className="text-orange-500" />
        <div>
          <h1 className="text-xl font-bold text-gray-800">Income vs Expenses</h1>
          <p className="text-xs text-gray-400">A rough monthly profit guide (revenue less petty cash)</p>
        </div>
      </div>
      <TabPnl />
    </div>
  );
}
